module.exports = __webpack_public_path__ + "media/images/home/logo2_small-d2b0384278a7178496b15ba395532208.png";